import { useMachine } from "@/queries/machine/use-machine";
import { taskKeys } from "@/queries/tasks/task-keys";
import { signal } from "@/signal/message";
import { useSignal } from "@/signal/use-signal";
import { useQueryClient } from "@tanstack/react-query";

const printingCompletedSignalFilter = (machineId?: string | null) =>
  `WorkcenterNId eq '${machineId}'`;

function printingCompletedSignal(machineId?: string | null) {
  return signal<{ d: [PrintingCompletedSignal] }>({
    enabled: !!machineId,
    app: "AppU4DM",
    channel: "APPMain_GF_PackingLabelPrinted",
    filters: printingCompletedSignalFilter(machineId),
  });
}

type PrintingCompletedSignal = { ProductId: string };

export function usePrintingCompletedSignal() {
  const { machine } = useMachine();
  const queryClient = useQueryClient();

  return useSignal(printingCompletedSignal(machine?.EquipmentNId), ({ d }) => {
    const key = taskKeys.getProductsWaitingForValidation(
      machine?.EquipmentNId,
      d[0].ProductId
    );

    return queryClient.invalidateQueries({ queryKey: key });
  });
}
